/**
 * Scripts that are tightly coupled to the collection template
 *
 * Compiles to ./dist/assets/scripts/template.collection.js
 */

/* eslint no-console: 0 */
import '../sections/sliderButtons';
